// The picture of a Venn diagram: a box, with its label above it, holding two
// overlapping circles with their names, and a number, a list or nothing in
// each part. Plain React SVG, like practice-graphs.tsx.

import {
  VENN_TEXT_SIZE,
  describeVenn,
  vennPicture,
  type VennSpec,
} from './practice-venn-data';

const INK = '#2d4a3e';
const FILL = '#eef3ee';

const fixed = (value: number) => value.toFixed(2);

export function VennView({ venn }: { venn: VennSpec }) {
  const picture = vennPicture(venn);
  // The reader refuses anything that does not fit, so this never happens.
  if (!picture) return null;
  const { box, frame } = picture;

  return (
    <figure className="m-0 max-w-md">
      <svg
        role="img"
        aria-label={describeVenn(venn)}
        viewBox={`${fixed(box.x)} ${fixed(box.y)} ${fixed(box.width)} ${fixed(box.height)}`}
        className="mx-auto block h-auto w-full"
        style={{ maxWidth: `${String(Math.round(box.width * 1.4))}px` }}
      >
        <rect
          data-part="box"
          x={fixed(frame.x)}
          y={fixed(frame.y)}
          width={fixed(frame.width)}
          height={fixed(frame.height)}
          fill="#ffffff"
          stroke={INK}
          strokeWidth="2"
        />
        {/* Both circles are filled before either is outlined, so each
            outline shows in full across the overlap. */}
        {picture.centres.map((centre, index) => (
          <circle
            key={index}
            cx={fixed(centre)}
            cy="0"
            r={fixed(picture.radius)}
            fill={FILL}
            fillOpacity="0.6"
            stroke="none"
          />
        ))}
        {picture.centres.map((centre, index) => (
          <circle
            key={index}
            data-part="circle"
            cx={fixed(centre)}
            cy="0"
            r={fixed(picture.radius)}
            fill="none"
            stroke={INK}
            strokeWidth="2.2"
          />
        ))}
        {picture.texts.map((text, index) => (
          <text
            key={index}
            data-label={text.part}
            x={fixed(text.x)}
            y={fixed(text.y)}
            dy="0.35em"
            textAnchor={text.anchor}
            fill={INK}
            fontSize={VENN_TEXT_SIZE}
            fontWeight="700"
          >
            {text.text}
          </text>
        ))}
      </svg>
    </figure>
  );
}
